import script from "./StatisticsMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatisticsMenu.vue?vue&type=script&lang=ts&setup=true"

import "./StatisticsMenu.vue?vue&type=style&index=0&id=e552c5f8&lang=css"

const __exports__ = script;

export default __exports__